import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangleIcon, UploadIcon, CheckCircleIcon } from 'lucide-react';
import { TopBar } from '../components/TopBar';
interface ReportProblemProps {
  navigate: (screen: string) => void;
}
export function ReportProblem({
  navigate
}: ReportProblemProps) {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    category: '',
    description: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.category && formData.description) {
      setSubmitted(true);
      setTimeout(() => {
        navigate('profile');
      }, 3000);
    }
  };
  return <div className="flex-1 bg-slate-50 flex flex-col h-full overflow-y-auto pb-safe" data-id="element-2848">
      <TopBar title="Report a Problem" showBack onBack={() => navigate('profile')} data-id="element-2849" />

      <div className="px-5 pt-6 pb-8" data-id="element-2850">
        <AnimatePresence mode="wait" data-id="element-2851">
          {submitted ? <motion.div key="success" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="bg-white rounded-3xl p-8 text-center shadow-sm border border-gray-100 mt-10" data-id="element-2852">
              <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2853">
                <CheckCircleIcon className="w-10 h-10 text-emerald-600" data-id="element-2854" />
              </div>
              <h2 className="text-2xl font-black text-[#0D3B3B] mb-2" data-id="element-2855">
                Report Submitted
              </h2>
              <p className="text-gray-500 text-sm mb-6" data-id="element-2856">
                Thank you for letting us know. Our team will investigate the
                issue and get back to you shortly.
              </p>
              <button onClick={() => navigate('profile')} className="w-full bg-[#0D3B3B] text-white py-4 rounded-xl font-bold" data-id="element-2857">
                Back to Profile
              </button>
            </motion.div> : <motion.div key="form" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-2858">
              <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 mb-6 flex gap-3" data-id="element-2859">
                <AlertTriangleIcon className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" data-id="element-2860" />
                <p className="text-sm text-amber-800" data-id="element-2861">
                  Please provide as much detail as possible so we can resolve
                  your issue quickly.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2862">
                <div className="space-y-2" data-id="element-2863">
                  <label className="text-sm font-bold text-[#0D3B3B] ml-1" data-id="element-2864">
                    Issue Category
                  </label>
                  <select required value={formData.category} onChange={e => setFormData({
                ...formData,
                category: e.target.value
              })} className="w-full bg-white border border-gray-200 rounded-xl py-4 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] transition-all appearance-none" data-id="element-2865">
                    <option value="" disabled data-id="element-2866">
                      Select a category
                    </option>
                    <option value="app_bug" data-id="element-2867">App Bug / Glitch</option>
                    <option value="payment" data-id="element-2868">Payment Issue</option>
                    <option value="account" data-id="element-2869">Account Access</option>
                    <option value="policy" data-id="element-2870">Policy / Claims</option>
                    <option value="other" data-id="element-2871">Other</option>
                  </select>
                </div>

                <div className="space-y-2" data-id="element-2872">
                  <label className="text-sm font-bold text-[#0D3B3B] ml-1" data-id="element-2873">
                    Description
                  </label>
                  <textarea required value={formData.description} onChange={e => setFormData({
                ...formData,
                description: e.target.value
              })} placeholder="Please describe the problem in detail..." rows={5} className="w-full bg-white border border-gray-200 rounded-xl py-4 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] transition-all resize-none" data-id="element-2874" />
                </div>

                <div className="space-y-2" data-id="element-2875">
                  <label className="text-sm font-bold text-[#0D3B3B] ml-1" data-id="element-2876">
                    Attachment (Optional)
                  </label>
                  <div className="w-full border-2 border-dashed border-gray-300 rounded-xl p-6 flex flex-col items-center justify-center bg-white hover:bg-gray-50 transition-colors cursor-pointer" data-id="element-2877">
                    <UploadIcon className="w-8 h-8 text-gray-400 mb-2" data-id="element-2878" />
                    <p className="text-sm font-medium text-[#0D3B3B]" data-id="element-2879">
                      Tap to upload screenshot
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-2880">
                      JPG, PNG or PDF (Max 5MB)
                    </p>
                  </div>
                </div>

                <button type="submit" className="w-full bg-[#0D3B3B] text-white py-4 rounded-xl font-bold mt-4 shadow-lg shadow-[#0D3B3B]/20 active:scale-95 transition-transform" data-id="element-2881">
                  Submit Report
                </button>
              </form>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}